
import { useSettingsStore } from '@/app/store/settingsModule';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AppearanceOptions extends Vue {
  get settingsStore() {
    return useSettingsStore();
  }
}
